import React from "react";
import { Heart, Globe, ExternalLink } from "lucide-react";

export const SITE_URL = "https://samantha-hellsehen-kartenlegen.de";
export const SITE_LABEL = "samantha-hellsehen-kartenlegen.de";

export const Header = ({ lang, setLang, t, onHome }) => (
  <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/50 border-b border-primary/20">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-3">
      <button
        data-testid="home-link"
        onClick={onHome}
        className="flex items-center gap-2.5 group shrink-0"
      >
        <Heart className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" fill="currentColor" />
        <span className="font-serif-display text-lg sm:text-xl tracking-wide gold-text">{t.nav_title}</span>
      </button>

      <div className="flex items-center gap-3 sm:gap-5">
        <a
          href={SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="site-url-link"
          className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary/90 hover:text-primary tracking-wide transition-colors"
        >
          {SITE_LABEL}
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
        <div className="flex items-center gap-1 rounded-full border border-primary/30 p-1">
          <Globe className="w-4 h-4 text-muted-foreground ml-2 mr-1" />
          {["de", "en"].map((l) => (
            <button
              key={l}
              data-testid={`lang-${l}`}
              onClick={() => setLang(l)}
              className={`px-3 py-1 text-xs uppercase tracking-[0.15em] rounded-full transition-colors ${
                lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </div>
  </header>
);
